import { Box, Divider, capitalize } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Asset } from '/src/lib/models';

export type AssetDetailsProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Asset to display details for
   */
  asset?: Asset;
};

export const AssetDetails: React.FC<AssetDetailsProps> = ({ asset, open, toggleOpen }) => (
  <SidebarItem title="Asset Details" open={open} toggleOpen={toggleOpen} resolved={!!asset}>
    <InfoItem title="Effective Date" value={asset?.effectiveDate} date />
    <InfoItem title="Asset Type" value={asset?.assetType} />
    <InfoItem title="Program" value={asset?.program} />
    <Divider />
    {asset?.loan.isOwned && (
      <Box>
        <InfoItem title="Administrative Fee" value={asset?.adminFee ?? 0} currency />
        <InfoItem title="Discount Fee" value={asset?.discountFee ?? 0} currency />
        <InfoItem title="Late Fee" value={asset?.lateFee ?? 0} currency />
        <InfoItem title="Fee Balance" value={asset?.feeBalance ?? 0} currency />
        <Divider />
        <InfoItem title="Initial Payment Amount" value={asset?.initialPaymentAmount ?? 0} currency />
        <InfoItem title="Expected Residual Payment" value={asset?.expectedResidualPayment ?? 0} currency />
        <Divider />
      </Box>
    )}
    <InfoItem title="Deal" value={asset?.loan?.name} url={`/deals/${asset?.loan._id}`} />
    <Divider />
    <InfoItem title="Status" value={capitalize(asset?.status ?? '')} />
  </SidebarItem>
);
